import script from "./TransactionFee.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionFee.vue?vue&type=script&setup=true&lang=js"

import "./TransactionFee.vue?vue&type=style&index=0&id=0ffaa10d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffaa10d"]])

export default __exports__